import { Dispatch, Fragment } from "react"
import { getS3UrlFromFileId, toBase64 } from "../../helpers/file_helper";
import Dropzone from "react-dropzone";
import { UploadCloud } from "lucide-react";
import { Link } from "react-router-dom";
import { FileObject } from "../../services/file.service";

type DropZoneImageProps = {
  selectfiles: Array<File & { base64: string }>,
  setSelectfiles: Dispatch<Array<File & { base64: string }>>
  formikData?: any
  fieldName?: string
  maxFiles?: number
  files?: FileObject[] | FileObject
  filesType?: 'file' | 'url'
}

const DropZoneImage = ({
  selectfiles,
  setSelectfiles,
  formikData,
  fieldName,
  maxFiles,
  files,
  filesType,
}: DropZoneImageProps) => {

  const handleAcceptfiles = async (files: any) => {
    const results = []
    if (maxFiles === 1) {
      formikData.setFieldValue(fieldName, '')
    }
    for (const file of files) {
      const fileType = file.name.split('.').pop()
      results.push(Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
        base64: await toBase64(file),
        filename: new Date().valueOf() + '.' + fileType,
      }));
    }
    setSelectfiles(results);
  };

  const formatBytes = (bytes: any, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };

  return (
    <Fragment>
      <Dropzone
        accept={{ "image/*": ['.png', '.jpg', '.jpeg'] }}
        maxFiles={maxFiles || 5}
        onDrop={(acceptfiles: any) => {
          handleAcceptfiles(acceptfiles);
        }}>
        {({ getRootProps }: any) => (
          <div className="flex items-center justify-center bg-white border border-dashed rounded-md cursor-pointer dropzone border-slate-300 dark:bg-zink-700 dark:border-zink-500 dropzone2">
            <div className="w-full py-5 text-lg text-center dz-message needsclick" {...getRootProps()} >
              <div className="mb-3">
                <UploadCloud className="block w-12 h-12 mx-auto text-slate-500 fill-slate-200 dark:text-zink-200 dark:fill-zink-500" />
              </div>
              <h5 className="mb-0 font-normal text-slate-500 dark:text-zink-200 text-15">Drag and drop your product images or <Link to="#!">browse</Link> your product images</h5>
            </div>
          </div>
        )}
      </Dropzone>
      <ul className="flex flex-wrap mb-0 gap-x-5" id="dropzone-preview2">
        {
          formikData && fieldName && Array.isArray(files) &&
          files?.map((file: any, index: number) => {
            return (
              <li className="mt-5" id="dropzone-preview-list2" key={index}>
                <div className="border rounded border-slate-200 dark:border-zink-500">
                  <div className="p-2 text-center">
                    <div>
                      <div className="p-2 mx-auto rounded-md w-14 h-14 bg-slate-100 dark:bg-zink-600">
                        <img className="block w-full h-full rounded-md" src={getS3UrlFromFileId(file.fileId, files, filesType)} alt={file.fileId} />
                      </div>
                    </div>
                    <div className="mt-2">
                      <button
                        type="button"
                        data-dz-remove
                        className="px-2 py-1.5 text-xs text-white bg-red-500 border-red-500 btn hover:text-white hover:bg-red-600 hover:border-red-600 focus:text-white focus:bg-red-600 focus:border-red-600 focus:ring focus:ring-red-100 active:text-white active:bg-red-600 active:border-red-600 active:ring active:ring-red-100 dark:ring-custom-400/20"
                        onClick={() => {
                          const newImages = [...formikData.values[fieldName]];
                        newImages.splice(index, 1);
                        formikData.setFieldValue(fieldName, newImages);
                      }}>Delete</button>
                    </div>
                  </div>
                </div>
              </li>
            );
          })
        }
        {
          formikData &&
          fieldName &&
          !Array.isArray(files) &&
          ((typeof files !== 'string' && files?.fileId) || (typeof files === 'string' && files)) &&
          <li className="mt-5" id="dropzone-preview-list2">
            <div className="border rounded border-slate-200 dark:border-zink-500">
              <div className="p-2 text-center">
                <div>
                  <div className="p-2 mx-auto rounded-md w-14 h-14 bg-slate-100 dark:bg-zink-600">
                    <img
                      className="block w-full h-full rounded-md"
                      src={filesType === 'url' && typeof files === 'string' ? files : files?.s3Url}
                      alt={filesType === 'url' && typeof files === 'string' ? files : files?.fileId}
                    />
                  </div>
                </div>
                <div className="mt-2">
                  <button
                    type="button"
                    data-dz-remove
                    className="px-2 py-1.5 text-xs text-white bg-red-500 border-red-500 btn hover:text-white hover:bg-red-600 hover:border-red-600 focus:text-white focus:bg-red-600 focus:border-red-600 focus:ring focus:ring-red-100 active:text-white active:bg-red-600 active:border-red-600 active:ring active:ring-red-100 dark:ring-custom-400/20"
                    onClick={() => {
                      formikData.setFieldValue(fieldName, '');
                    }}>Delete</button>
                </div>
              </div>
            </div>
          </li>
        }
        {
          (selectfiles || [])?.map((file: any, index: number) => {
            return (
              <li className="mt-5" id="dropzone-preview-list2" key={index}>
                <div className="border rounded border-slate-200 dark:border-zink-500">
                  <div className="p-2 text-center">
                    <div>
                      <div className="p-2 mx-auto rounded-md w-14 h-14 bg-slate-100 dark:bg-zink-600">
                        <img className="block w-full h-full rounded-md" src={file.preview} alt={file.name} />
                      </div>
                    </div>
                    <div className="pt-3">
                      <strong className="error text-danger" data-dz-errormessage></strong>
                    </div>
                    <div className="mt-2">
                      <button
                        type="button"
                        data-dz-remove
                        className="px-2 py-1.5 text-xs text-white bg-red-500 border-red-500 btn hover:text-white hover:bg-red-600 hover:border-red-600 focus:text-white focus:bg-red-600 focus:border-red-600 focus:ring focus:ring-red-100 active:text-white active:bg-red-600 active:border-red-600 active:ring active:ring-red-100 dark:ring-custom-400/20"
                        onClick={() => {
                          const newImages = [...selectfiles];
                        newImages.splice(index, 1);
                        setSelectfiles(newImages);
                      }}>Delete</button>
                    </div>
                  </div>
                </div>
              </li>
            );
          })
        }
      </ul>
    </Fragment>
  )
}

export default DropZoneImage